export default {
  // Listado paginado: { data: [], total, per_page, current_page, last_page }
  conversaciones: null,
  // Detalle: conversación con mensajes + agentes + cliente
  detalle: null,

  loading: false,
  loadingDetalle: false,

  filtros: {
    search: '',
    canal: null,
    // Por defecto sólo se listan las conversaciones "Abiertas" (open).
    estado: 'open',
    match_estado: null,
    con_cliente: null,
    id_cliente: null
  },

  page: 1,
  perPage: 20
}
